/**
 * Movil y tableta: el mapa y las escenas 3D a pantalla completa, con la cabecera, los paneles y las
 * barras de opciones detras de un boton de menu (☰). La consulta tiene que coincidir con la de
 * styles.css («Movil y tableta»).
 */
import { h } from './dom';

/** Pantallas estrechas, o tactiles hasta una tableta grande en horizontal. */
export const CONSULTA_MOVIL = '(max-width: 1024px), (pointer: coarse) and (max-width: 1400px)';

export function consultaMovil(): MediaQueryList | null {
  try { return window.matchMedia(CONSULTA_MOVIL); } catch { return null; }
}

const ICONO_MENU = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

/**
 * Boton ☰ que pone y quita la clase `menu-abierto` en `contenedor` (el CSS decide que se muestra).
 * Solo se ve en movil y tableta.
 */
export function botonMenu(contenedor: HTMLElement, alCambiar?: (abierto: boolean) => void): HTMLButtonElement {
  const b = h('button', {
    class: 'boton-menu', type: 'button', 'aria-label': 'Menú', title: 'Menú', 'aria-expanded': 'false',
    onClick: () => ponerMenu(contenedor, !contenedor.classList.contains('menu-abierto'), b, alCambiar),
  });
  b.innerHTML = ICONO_MENU;
  return b;
}

export function ponerMenu(contenedor: HTMLElement, abierto: boolean, boton?: HTMLElement, alCambiar?: (abierto: boolean) => void): void {
  if (contenedor.classList.contains('menu-abierto') === abierto) return;
  contenedor.classList.toggle('menu-abierto', abierto);
  boton?.setAttribute('aria-expanded', String(abierto));
  alCambiar?.(abierto);
}

/**
 * Menu de una escena 3D (`.escena-lidar`): en movil y tableta la barra de opciones se esconde y se
 * despliega desde arriba con el boton ☰; tocar la escena la vuelve a esconder.
 */
export function menuEscena(capa: HTMLElement, lienzo: HTMLElement): void {
  const boton = botonMenu(capa);
  capa.append(boton);
  lienzo.addEventListener('pointerdown', () => ponerMenu(capa, false, boton));
  // Los botones de la barra (Revisar, plantas, Vistas PDF, el paseo...) abren algo en la escena: se
  // pliega la barra para no taparlo. Las casillas, listas y deslizadores la dejan abierta.
  capa.querySelector('.escena-barra')?.addEventListener('click', (ev) => {
    if ((ev.target as Element).closest('button')) ponerMenu(capa, false, boton);
  });
}
